// extracted by mini-css-extract-plugin
export default {"root":"mimic___styles_root__ql3S3","tagsInput":"mimic___styles_tagsInput__PTBaO"};